{
  "moreActions": "További lehetőségek"
}
